import EditFileForm from 'features/media/components/molecules/EditFileForm/EditFileForm';

export default EditFileForm;
